import { css } from '@emotion/react'
import styled from '@emotion/styled'

const titleContainerStyles = ({ theme }) => css`
  label: title--container;

  display: flex;
  justify-content: space-between;
  align-items: end;

  ${theme.media.mega} {
    cursor: pointer;
  }
`

const contentStyles = ({ theme }) => css`
  label: content;

  margin: 0 0 20px 0;

  color: ${theme.colors.n600};
`

const contentContainerStyles = () => css`
  label: content__container;

  will-change: max-height;

  overflow: hidden;

  transition: max-height 455ms cubic-bezier(0.785, 0.135, 0.15, 0.86);
`

export const TitleContainer = styled('div')(titleContainerStyles)
export const Content = styled('p')(contentStyles)
export const ContentContainer = styled('div')(contentContainerStyles)
